import { TUTORIAL_DEMO_ENTRY_QUICK_DARKEN_MS } from '@/constants/professionalTutorialDemo';

export const TUTORIAL_DEMO_ENTRY_OVERLAY_ID =
	'plumaa-tutorial-demo-entry-overlay';

/**
 * Cortina preta imperativa no `body` — sobrevive à troca de rota home → demo.
 */
export function mountTutorialDemoEntryBlackOverlay(options?: {
	animateIn?: boolean;
}): void {
	if (document.getElementById(TUTORIAL_DEMO_ENTRY_OVERLAY_ID)) return;

	const overlay = document.createElement('div');
	overlay.id = TUTORIAL_DEMO_ENTRY_OVERLAY_ID;
	overlay.setAttribute('aria-hidden', 'true');
	Object.assign(overlay.style, {
		position: 'fixed',
		inset: '0',
		background: '#000',
		zIndex: '10050',
		pointerEvents: 'auto',
		opacity: options?.animateIn ? '0' : '1',
		transition: options?.animateIn
			? `opacity ${TUTORIAL_DEMO_ENTRY_QUICK_DARKEN_MS}ms ease-out`
			: 'none',
	});

	document.body.appendChild(overlay);
	document.body.style.overflow = 'hidden';

	if (!options?.animateIn) return;

	requestAnimationFrame(() => {
		overlay.style.opacity = '1';
	});
}

export function unmountTutorialDemoEntryBlackOverlay(): void {
	document.getElementById(TUTORIAL_DEMO_ENTRY_OVERLAY_ID)?.remove();

	if (!document.querySelector('[data-tutorial-demo-entry-curtain]')) {
		document.body.style.overflow = 'auto';
	}
}
